export default __webpack_public_path__ + "static/media/gunBody.da422758.png";